import React from 'react';
import { render } from 'react-dom';
import config from 'shared/config';
import history from 'redux/history';
import store from 'redux/store';
import { actions as LoginActions } from 'redux/domain/User';
import { actions as NavBarActions } from 'redux/domain/NavBar';
import { actions as ProductModalActions } from 'redux/domain/ProductModal';

import 'normalize.css';
import routes from './routes';

if (process.env.NODE_ENV === 'development') {
	// attach react dev tools to window
	if (typeof window !== 'undefined') {
		window.React = React;
	}
}

/**
 * go back to the Homepage and log out the logged in user
 */
const backToHomepage = () => {
	// logout user
	// Guest users also get logged out because guest users have a customer id, which is used to
	// track the shopping cart and/or wishlist. Assume the user has walked away.
	store.dispatch(LoginActions.logout());
	store.dispatch(NavBarActions.closeMainDrawer());
	store.dispatch(NavBarActions.closeCartDrawer());
	store.dispatch(NavBarActions.deleteChip());
	store.dispatch(ProductModalActions.hideProductModal());
	history.push('/kiosk/welcome');
	history.go('/kiosk/welcome');
};

// create the timeout for inactivity
let ELAPSED_INACTIVE_TIME = window.setTimeout(backToHomepage, config.MAX_INACTIVE_TIME);

const resetTimeout = () => {
	window.clearTimeout(ELAPSED_INACTIVE_TIME);
	// clearTimeout cancels setTimeout's execution so reset setTimeout
	ELAPSED_INACTIVE_TIME = window.setTimeout(backToHomepage, config.MAX_INACTIVE_TIME);
};

// the activity indicator is a click so reset the timeout timer
// when a user clicks
window.addEventListener('click', resetTimeout);

if (
	config.SingleSignOn.STORISSingleSignOnEnabled &&
	config.SingleSignOn.ExtLoginJWTToken !== null &&
	config.SingleSignOn.ExtLoginJWTToken !== ''
) {
	store.dispatch(
		LoginActions.loginExernalUser(
			config.SingleSignOn.ExtLoginJWTToken,
			config.SingleSignOn.ExtLoginName,
			config.SingleSignOn.ExtLoginEmail,
		),
	);
	config.SingleSignOn.ExtLoginJWTToken = null;
	config.SingleSignOn.ExtLoginName = null;
	config.SingleSignOn.ExtLoginEmail = null;
}

render(routes, document.querySelector('#main'));
